import RestaurantsSettings from './modules/RestaurantsSettings';
import Meals from './modules/Meals';

const restaurantsStore = {
   RestaurantsSettings,
   Meals,
};

export default restaurantsStore;
